<div class="flex flex-col items-center justify-center h-full">
  <img src="/icons/error_icon.svg" class="w-52" />
  <h1 class="text-3xl font-bold text-primary mt-8">Accès Refusé</h1>
  <p class="text-primary mt-2">
    Vous n'avez pas les autorisations nécessaires pour accéder à cette
    application.
  </p>
  <a
    (click)="navigateToLogin()"
    class="inline-flex items-center mt-6 font-semibold py-2 px-8 text-white bg-secondary rounded-2xl hover:bg-primary transition duration-300 cursor-pointer"
  >
    <mat-icon class="mr-2">login</mat-icon>
    Connectez-vous
  </a>
</div>
